module.exports = __webpack_public_path__ + "static/bgAsset-nx-48cc91580254d5d8be0d2f32395ab950.jpg";